import client from './api-client';

export const serviceGetCfgForm = async (query) => {
    try {
        const response = await client.getSelect(`cfg-forms?q=${query}`);

        if (response.status === 200 && response.data.code === 1) return response.data.object
        else throw new Error(response.data.message);
    }
    catch (error) {
        throw error;
    }
}

export const serviceGetDetalles = async (query) => {
    try {
        const response = await client.getSelect(`detalles?q=${query}`);
      
        if (response.status === 200 && response.data.code === 1) return response.data.object
        else throw new Error(response.data.message);
    } 
    catch(error){
        throw error;
    }
}

export const serviceGetEstadoSituacion = async (query) => {
    try {
        const response = await client.get(`caso/recobro/antec-respuesta?q=${query}`);
      
        if (response.status === 200 && response.data.code === 1) return response.data.object
        else throw new Error(response.data.message);
    } 
    catch(error){
        throw error;
    }
}

export const serviceGetDocumento = async(query) => {
    try {
        const response = await client.getDocumento(`get-file?q=${query}`);
        if (response.status === 200 && response.data.code === 1) {
            return response.data
        } else {
            throw new Error(response.data.message);
        }

    } catch(error){
        throw error;
    }
}

export const serviceProcesarRespuesta = async(body) => {
    try {
        const response = await client.post('caso/cobro-tercero/aprobacion', body);
        return response.data;
    } catch(error) {
        throw error;
    }
}

export const serviceGetDestinatarios = async (query) => {
    try {
        const response = await client.getSelect(`gestion-implicado/cierre-defensa/destinatarios-carta?q=${query}`);
      
        if (response.status === 200 && response.data.code === 1) return response.data.object
        else throw new Error(response.data.message);
    } 
    catch(error){
        throw error;
    }
}
export const serviceActualizarDestinatario = async(body) => {
    try {
        const response = await client.postCia('gestion-implicado/cierre-defensa/destinatarios-carta', body);
        return response.data;
    } catch(error) {
        throw error;
    }
}
export const serviceGetRequisitos = async (query) => {
    try {
        const response = await client.get(`requisitos-gestion?q=${query}`);
      
        if (response.status === 200 && response.data.code === 1) return response.data.object
        else throw new Error(response.data.message);
    } 
    catch(error){
        throw error;
    }
}
export const serviceGetDocumentos = async (query) => {
    try {
        const response = await client.get(`caso/recobro/documentos?q=${query}`);
      
        if (response.status === 200 && response.data.code === 1) return response.data.object
        else throw new Error(response.data.message);
    } 
    catch(error){
        throw error;
    }
}
export const serviceDeleteDocumento = async(body) => {
    try {
        const response = await client.post('caso/recobro/delete-file', body);
        return response.data;
    } catch(error) {
        throw error;
    }
}
export const serviceGetProveedores = async (query) => {
    try {
        const response = await client.getSelect(`proveedores-rol?q=${query}`);
      
        if (response.status === 200 && response.data.code === 1) return response.data.object
        else throw new Error(response.data.message);
    } 
    catch(error){
        throw error;
    }
}